export const LoadingMoreIndicator = () => <div style={{ width: '100%', textAlign: 'center' }}>Loading</div>;

export default LoadingMoreIndicator;
